"use client";

import Image from "next/image";
import React from "react";
import style from "./unionProducts.module.scss";
import { awsS3BaseURL } from "@/lib/Constants";
import { useRouter } from "next/navigation";
import { Products, ProductsUnionProducts, ProductUnionType } from "@/common/entities/product/Product";
import ProductsUtils from "@/common/utils/ProductsUtils";

interface Props {
    unionProducts: ProductsUnionProducts[];
    currentProduct: Products;
}

const UnionProductVariants = ({ unionProducts, currentProduct }: Props) => {
    const router = useRouter();

    const colorVariants = unionProducts.filter(
        (up) => up.productsUnion?.type === ProductUnionType.color
    );
    const sizeVariants = unionProducts.filter(
        (up) => up.productsUnion?.type === ProductUnionType.size
    );

    const selectedColorValue = colorVariants.find((up) => up.product?.url === currentProduct.url)?.value || "";
    const selectedSizeValue = sizeVariants.find((up) => up.product?.url === currentProduct.url)?.value || "";

    const renderVariants = (
        variants: ProductsUnionProducts[],
        label: string,
        selectedValue: string,
        type: ProductUnionType
    ) => {
        if (variants.length === 0) return null;

        return (
            <div className="mb-4 mt-4">
                <p className={style.label}>
                    {label} <strong>{selectedValue}</strong>
                </p>
                <div className="d-flex flex-wrap mb-3">
                    {variants.map((unionProduct, index) => {
                        const linkedProduct = unionProduct.product;
                        const imageUrl = linkedProduct?.defaultImage?.image.originalFileName;
                        const isSelected = linkedProduct?.url === currentProduct.url;
                        const link = ProductsUtils.getProductLink(linkedProduct.url, linkedProduct.categories) || "";

                        return (
                            <button
                                key={index}
                                type="button"
                                className={`${style.variantItem} me-2 mb-2`}
                                style={{
                                    border: isSelected ? "2px solid #000" : "1px solid #ccc",
                                    padding: "4px",
                                    borderRadius: type === ProductUnionType.color ? "4px" : "50px",
                                    cursor: "pointer",
                                    width: "60px",
                                    height: "60px",
                                    backgroundColor: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                }}
                                title={unionProduct.value}
                                onClick={() => {
                                    if (!isSelected && linkedProduct?.url) {
                                        router.push(`${link}`);
                                    }
                                }}
                            >
                                {type === ProductUnionType.color && imageUrl ? (
                                    <Image
                                        src={awsS3BaseURL + imageUrl}
                                        alt={unionProduct.value}
                                        width={60}
                                        height={60}
                                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                                    />
                                ) : (
                                    unionProduct.value
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div>
            {renderVariants(colorVariants, "Alege culoare:", selectedColorValue, ProductUnionType.color)}
            {renderVariants(sizeVariants, "Alege marime:", selectedSizeValue, ProductUnionType.size)}
        </div>
    );
};

export default UnionProductVariants;
